import { JobSuggestedCandidate } from "@container/employer-suggested-candidate";
import AuthLayout from "@container/layout/auth";

export default function EmployerSuggestedCandidate() {
    return (
        <AuthLayout>
            <JobSuggestedCandidate />
        </AuthLayout>
    );
}
